'use client'

import { useReducer, createContext, useContext, useEffect } from 'react'
import Reducer from './Reducer'
import { loadInitial } from './functions'

import Loading from '@/components/Loading/Loading'

export const DashboardContext = createContext()

const DashboardContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(Reducer, {
        user: null,
        companies: [],
        partnerships: [],
        loaded: false,
        selected: null,
        sidebarOpen: false,
    })

    loadInitial(dispatch)

    return (
        <DashboardContext.Provider
            value={{
                state,
                dispatch,
            }}
        >
            {/* <Loading visible={!state.loaded} /> */}
            {state.loaded && children}
        </DashboardContext.Provider>
    )
}

const useEngine = () => {
    const context = useContext(DashboardContext)
    if (context === undefined) {
        throw new Error('useEngine must be used within a DashboardContextProvider')
    }

    return context
}

export { DashboardContextProvider, useEngine }
